// extracted by mini-css-extract-plugin
export default {"sidebar":"style_sidebar__8lB3D","background":"style_background__QeBv3","container":"style_container__gwmRm","content":"style_content__256Tl","main":"style_main__XLsfu"};